export interface ModelDomicilesInformationPayload {
  id?: number;
  servicesToEmployee?: number;
  case?: number;
  domicileModelTypes?: number;
  roadTypes?: number;
  roadName?: string;
  numberTypes?: number;
  number?: string;
  qualifierTypes?: number;
  block?: string;
  building?: string;
  stair?: string;
  floorFlat?: string;
  door?: string;
  complement?: string;
  location?: string;
  postalCode?: string;
  province?: number;
  municipality?: number;
  domicileCountry?: number;
  region?: string;
  emailAddress?: string;
  phoneNumber?: string;
  landLinePhone?: string;
  ownership?: number;
  ownershipPercentage?: number;
  cadastralReference?: string;
  filed030?: boolean;
  changeDomicile?: boolean;
}

function toNumber(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function toBoolean(value: unknown): boolean | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  if (value === 'true') {
    return true;
  }
  if (value === 'false') {
    return false;
  }
  return undefined;
}

function toStringValue(value: unknown): string | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  const text = String(value).trim();
  return text.length > 0 ? text : undefined;
}

export function buildModelDomicilesInformationPayload(input: any): ModelDomicilesInformationPayload {
  const payload: ModelDomicilesInformationPayload = {};

  const id = toNumber(input?.id);
  if (id !== undefined) payload.id = id;

  const servicesToEmployee = toNumber(input?.servicesToEmployee);
  if (servicesToEmployee !== undefined) payload.servicesToEmployee = servicesToEmployee;

  const caseId = toNumber(input?.case);
  if (caseId !== undefined) payload.case = caseId;

  const domicileModelTypes = toNumber(input?.domicileModelTypes);
  if (domicileModelTypes !== undefined) payload.domicileModelTypes = domicileModelTypes;

  const roadTypes = toNumber(input?.roadTypes);
  if (roadTypes !== undefined) payload.roadTypes = roadTypes;

  const roadName = toStringValue(input?.roadName);
  if (roadName !== undefined) payload.roadName = roadName;

  const numberTypes = toNumber(input?.numberTypes);
  if (numberTypes !== undefined) payload.numberTypes = numberTypes;

  const number = toStringValue(input?.number);
  if (number !== undefined) payload.number = number;

  const qualifierTypes = toNumber(input?.qualifierTypes);
  if (qualifierTypes !== undefined) payload.qualifierTypes = qualifierTypes;

  const block = toStringValue(input?.block);
  if (block !== undefined) payload.block = block;

  const building = toStringValue(input?.building);
  if (building !== undefined) payload.building = building;

  const stair = toStringValue(input?.stair);
  if (stair !== undefined) payload.stair = stair;

  const floorFlat = toStringValue(input?.floorFlat);
  if (floorFlat !== undefined) payload.floorFlat = floorFlat;

  const door = toStringValue(input?.door);
  if (door !== undefined) payload.door = door;

  const complement = toStringValue(input?.complement);
  if (complement !== undefined) payload.complement = complement;

  const location = toStringValue(input?.location);
  if (location !== undefined) payload.location = location;

  const postalCode = toStringValue(input?.postalCode);
  if (postalCode !== undefined) payload.postalCode = postalCode;

  const province = toNumber(input?.province);
  if (province !== undefined) payload.province = province;

  const municipality = toNumber(input?.municipality);
  if (municipality !== undefined) payload.municipality = municipality;

  const domicileCountry = toNumber(input?.domicileCountry);
  if (domicileCountry !== undefined) payload.domicileCountry = domicileCountry;

  const region = toStringValue(input?.region);
  if (region !== undefined) payload.region = region;

  const emailAddress = toStringValue(input?.emailAddress);
  if (emailAddress !== undefined) payload.emailAddress = emailAddress;

  const phoneNumber = toStringValue(input?.phoneNumber);
  if (phoneNumber !== undefined) payload.phoneNumber = phoneNumber;

  const landLinePhone = toStringValue(input?.landLinePhone);
  if (landLinePhone !== undefined) payload.landLinePhone = landLinePhone;

  const ownership = toNumber(input?.ownership);
  if (ownership !== undefined) payload.ownership = ownership;

  const ownershipPercentage = toNumber(input?.ownershipPercentage);
  if (ownershipPercentage !== undefined) payload.ownershipPercentage = ownershipPercentage;

  const cadastralReference = toStringValue(input?.cadastralReference);
  if (cadastralReference !== undefined) payload.cadastralReference = cadastralReference;

  const filed030 = toBoolean(input?.filed030);
  if (filed030 !== undefined) payload.filed030 = filed030;

  const changeDomicile = toBoolean(input?.changeDomicile);
  if (changeDomicile !== undefined) payload.changeDomicile = changeDomicile;

  return payload;
}
